var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86252 19.59L7.81877 0.576292C7.83997 0.435252 7.90515 0.304501 8.005 0.202666C8.10486 0.100831 8.23431 0.0331079 8.37491 0.00914403C8.5155 -0.0148198 8.66008 0.00619827 8.78803 0.069204C8.91599 0.13221 9.02079 0.233989 9.08752 0.360042L12.2663 6.32379L4.86252 19.59ZM25.855 24.205L23.0425 6.70504C23.0232 6.58137 22.9699 6.46549 22.8886 6.37036C22.8073 6.27523 22.7011 6.20459 22.5819 6.16633C22.4627 6.12808 22.3352 6.12371 22.2137 6.15373C22.0922 6.18374 21.9814 6.24695 21.8938 6.33629L4.14502 24.2063L13.965 29.74C14.2681 29.9103 14.6099 29.9998 14.9575 29.9998C15.3052 29.9998 15.6469 29.9103 15.95 29.74L25.855 24.205ZM17.875 8.93379L15.6 4.58129C15.5426 4.47184 15.4564 4.38017 15.3506 4.31621C15.2449 4.25225 15.1236 4.21844 15 4.21844C14.8764 4.21844 14.7552 4.25225 14.6494 4.31621C14.5437 4.38017 14.4574 4.47184 14.4 4.58129L4.41252 22.48L17.875 8.93379Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.37450d5f5290f26298ecdd89d75a865f.svg";
export { ForwardRef as ReactComponent };